import qualiopiLogo from "@/assets/qualiopi-logo.png";
import { Link } from 'react-router-dom';

interface QualiopiLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showMention?: boolean;
  className?: string;
  certificateUrl?: string;
}

export function QualiopiLogo({ size = 'md', showMention = false, className = '', certificateUrl }: QualiopiLogoProps) {
  const sizeClasses = {
    sm: 'w-24',      // 96px - conforme charte (>87px requis)
    md: 'w-36',      // 144px - sections normales
    lg: 'w-48'       // 192px - footer, pages dédiées
  };

  const containerPadding = {
    sm: 'p-2',
    md: 'p-3',
    lg: 'p-4'
  };

  const logoContent = (
    <div className={`bg-white rounded-lg ${containerPadding[size]} shadow-sm border border-gray-100 ${certificateUrl ? 'transition-opacity hover:opacity-80' : ''}`}>
      <img 
        src={qualiopiLogo}
        alt={certificateUrl ? "Logo Qualiopi - Cliquez pour consulter notre certificat" : "Logo Qualiopi - Certification qualité actions de formation"}
        className={`${sizeClasses[size]} h-auto object-contain`}
        loading="lazy"
      />
    </div>
  );

  return (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      {/* Logo avec fond blanc obligatoire et zone de protection */}
      {certificateUrl ? (
        <Link
          to="/certificat-qualiopi"
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer transition-opacity hover:opacity-80"
          aria-label="Consulter notre certificat Qualiopi (s'ouvre dans un nouvel onglet)"
        >
          {logoContent}
        </Link>
      ) : (
        logoContent
      )}
      
      {/* Mention réglementaire obligatoire */}
      {showMention && (
        <div className="text-xs text-center max-w-xs text-muted-foreground leading-relaxed">
          <p className="font-medium mb-1">
            La certification qualité a été délivrée au titre de la catégorie d'action suivante :
          </p>
          <p className="font-bold text-foreground">
            ACTIONS DE FORMATION
          </p>
        </div>
      )}
    </div>
  );
}
